import { SelectHTMLAttributes, forwardRef, ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/cn";

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  children: ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { label, id, className, children, ...rest }, ref
) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={id} className="text-xs font-medium text-text-muted">{label}</label>
      )}
      <div className="relative">
        <select
          id={id}
          ref={ref}
          className={cn(
            "h-9 w-full pl-3 pr-8 text-sm bg-bg-elevated border border-border rounded",
            "appearance-none focus:outline-none",
            className,
          )}
          {...rest}
        >
          {children}
        </select>
        <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 size-4 text-text-muted pointer-events-none" />
      </div>
    </div>
  );
});
